// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-7d69e2e5]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.setting-image[data-v-7d69e2e5]{align-items:center;background:hsla(0,0%,100%,.05);display:flex;flex:1;height:100%;justify-content:center;width:100%}.hepler-image[data-v-7d69e2e5]{min-height:100px;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
